module.exports = __webpack_public_path__ + "img/土拨鼠.b469a208.gif";